import React, { useEffect } from "react";
import {
  Router,
  Route,
  Switch,
  Redirect,
  Link,
  useLocation,
} from "react-router-dom";
import { createBrowserHistory } from "history";
import {
  AppBar,
  Toolbar,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Box,
  useMediaQuery,
} from "@mui/material";
//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Navbar + Logout---------------- 
import HorizontalNavbar from "./HorizontalNavbar";
import MobileBottomNav from "./MobileBottomNav";
import Logout from "./Logout";

//---------------- PWA Components---------------- 
import PWAStatus from "./components/common/PWAStatus";

//---------------- Service Worker Registration---------------- 
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';
import LodingComponent from "./loding";
// import Loginlogo from "./Loginlogo.png";

//---------------- Logo ----------------
import MampillyLogo from './components/pages/Logo/logo_Madavana.png';

//-----------SessionTimeOut---------
import SessionTimeout from "./SessionTimeout";

//-----------Company----------------
import CompanyEdit from "./components/pages/Company/Edit";

//-----------Home-------------------
import Home from "./components/pages/Home";
//-----------Role-------------------
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

//-----------User-------------------
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//-----------Product-------------------
import ProductCategoryIndex from "./components/pages/ProductCategory/Index";
import ProductSubCategoryIndex from "./components/pages/ProductCategory/SubCategoryIndex";
import ProductItemIndex from "./components/pages/ProductItem/Index";
import ProductBrandIndex from "./components/pages/ProductBrand/Index";
// import ProductRelationIndex from "./components/pages/ProductRelation/Index";

//-----------Bank-------------------
import BankIndex from "./components/pages/Bank/Index";

//-----------Master-------------------
import MasterDashboard from "./components/pages/Master/MasterDashboard";
import ClientIndex from "./components/pages/Master/ClientIndex";
import VendorIndex from "./components/pages/Master/VendorIndex";

//-----------AccountHead-------------------
import AccountHeadDashboard from "./components/pages/AccountHead/AccountHeadDashboard";
import AccountHeadIndex from "./components/pages/AccountHead/AccountHeadIndex";
import AssetIndex from "./components/pages/AccountHead/AssetIndex";
import CapitalIndex from "./components/pages/AccountHead/CapitalIndex";
import OtherOptionIndex from "./components/pages/AccountHead/OtherOptionIndex";
import SalesExecutiveIndex from "./components/pages/AccountHead/SalesExecutiveIndex";
import SalesManDashboard from "./components/pages/SalesMan/SalesManDashboard";
import SalesExecutiveDashboard from "./components/pages/SalesMan/SalesExecutiveDashboard";
import DriverDashboard from "./components/pages/Driver/DriverDashboard";
import BalanceSheetHeadIndex from "./components/pages/AccountHead/BalanceSheetHeadIndex";

//-----------Delivery / Schedules-------------------
import Schedules from "./components/pages/Delivery/Schedules";
import InstallationScheduleList from "./components/pages/Delivery/InstallationScheduleList";
import OnsiteExchangeList from "./components/pages/Delivery/OnsiteExchangeList";
import CashOnDeliveryList from "./components/pages/Delivery/CashOnDeliveryList";

//-----------PurchaseOrder-------------------
import PurchaseOrderIndex from "./components/pages/PurchaseOrder/PurchaseOrderIndex";

//-----------Purchase-------------------
import PurchaseIndex from "./components/pages/Purchase/PurchaseIndex";

//-----------PurchaseReturn-------------------
import PurchaseReturnAgainstIndex from "./components/pages/PurchaseReturn/PurchaseReturnAgainstIndex";

//-----------Enquiry-------------------
import EnquiryIndex from "./components/pages/Enquiry/EnquiryIndex";
import EnquiryForm from "./components/pages/Enquiry/EnquiryForm";

//-----------Scheme-------------------
import SchemeIndex from "./components/pages/Scheme/SchemeIndex";
import SchemeForm from "./components/pages/Scheme/SchemeForm";

//-----------Quotation-------------------
import QuotationIndex from "./components/pages/Quotation/QuotationIndex";

//-----------SalesOrder-------------------
import SalesOrderIndex from "./components/pages/SaleOrder/SalesOrderIndex";

//---- -------Sale-------------------
import SaleIndex from "./components/pages/Sale/SaleIndex";

//-----------SaleReturn-------------------
import SaleReturnIndex from "./components/pages/SaleReturn/SaleReturnIndex";

//-----------Stock-------------------
import StockTransferInIndex from "./components/pages/Stock/StockTransferInIndex";
import StockTransferOutIndex from "./components/pages/Stock/StockTransferOutIndex";

//-----------Production-------------------
import ProductionIndex from "./components/pages/Production/ProductionIndex";

//-----------PaymentReceipts-------------------
import PaymentReceiptsIndex from "./components/pages/PaymentReceipts/PaymentReceiptsIndex";

//-----------JournalEntry-------------------
import JournalEntryIndex from "./components/pages/JournalEntry/JournalEntryIndex";

//-----------Reports-------------------
import {
  LedgerReport, PurchaseReport, PurchaseOrderStatusReport, VendorandItemWisePurchaseReport,
  VendorAgeingReport, SaleReport, CustomerandItemWiseSaleReport, CustomerAgeingReport,
  SaleOrderStatusReport, SaleGstReport, StockTransferReport
} from "./components/pages/Reports";

import CashBook from "./components/pages/Reports/CashBook";
import ReportsHub from "./components/pages/Reports/ReportsHub";

//-----------PurchaseReports-------------------
import { PurchaseOrderWiseReport, PurchaseInvoiceRegister, PurchaseSummaryBillWise, PurchasePriceList, PurchasePaymentReminder, PurchaseBillWiseOutstanding, VendorBillWisePaymentDetails, VendorAgeingBillToBill, VendorAgeingFIFO, VendorGroupOutstandingReport } from "./components/pages/PurchaseReports";

//-----------SaleReports-------------------
import { SalePriceList, SaleInvoiceRegister, SaleSummaryBillWise, SalesManCommissionSummary, SalesManCommissionPending, SalesManCommissionExceeded, PaymentRemainder, BillWiseOutstanding, ClientBillWisePaymentDetails, ClientAgeingAnalysisBillWise, ClientAgeingFIFO, ClientGroupOutstandingReport, StaffSaleReport } from "./components/pages/SaleReports";

//-----------StockReports-------------------
import { StockMovementReport, StockSummaryReport, StockAnalysisReport, StockAgeingReport, RateAnalysisReport, ProductionWiseStockReport } from "./components/pages/StockReports";

//-----------FinancialStatementsReports-------------------
import { DelayedPaymentReport, DelayedCollectionReport, CollectionReport, PaymentsReport, JournalBookReport, BankReceiptJournalReport, BankPaymentJournalReport, DayBookReport, DayBookSummaryReport, SaleJournalReport, PurchaseJournalReport, FinancialJournalHub } from "./components/pages/FinancialStatementsReport";
import BankBookReport from "./components/pages/FinancialStatementsReport/BankBookReport";

//-----------MISReports-------------------
import RatioAnalysisReport from "./components/pages/MISReports/RatioAnalysisReport";
import SchemeSummaryReport from "./components/pages/MISReports/SchemeSummaryReport";
import DailyProfitReport from "./components/pages/MISReports/DailyProfitReport";
import StaffTargetReport from "./components/pages/MISReports/StaffTargetReport";
import StockBranchWiseReport from "./components/pages/MISReports/StockBranchWiseReport";
import CashOnDeliveryPaymentStatusReport from "./components/pages/MISReports/CashOnDeliveryPaymentStatusReport";
import CashFlowStatement from "./components/pages/MISReports/CashFlowStatement";
import ProfitLossMonthWise from "./components/pages/MISReports/ProfitLossMonthWise";
import FundFlowStatement from "./components/pages/MISReports/FundFlowStatement";
import BalanceSheet from "./components/pages/MISReports/BalanceSheet";
import BalanceSheetTView from "./components/pages/MISReports/BalanceSheetTView";
import TrialBalanceReport from "./components/pages/MISReports/TrialBalanceReport";
import TrialBalanceAdvancedReport from "./components/pages/MISReports/TrialBalanceAdvancedReport";
import IncomeExpenseReport from "./components/pages/AccountsReports/IncomeExpenseReport";
import ExpenseReport from "./components/pages/AccountsReports/ExpenseReport";
import DetailedInvoiceReport from "./components/pages/AccountsReports/DetailedInvoiceReport";

//-----------ItemProfitabilityReports-------------------
import { StockBasedReport, SalesBasedReport, BatchBasedReport, PartyWiseReport, SalesManWiseReport, StockMinimalLevelReport, ItemMovementAnalysisReport } from "./components/pages/ItemProfitabilityReports";

//-----------InventoryReports------------------- 
import { StockDayBook, StockLedger, DailyItemMovement, MonthlyItemMovement, FastSlowMovingItems, StockTrail, StockTrailMonthWise, StockValuation, StockTransferInventory } from "./components/pages/InventoryReports";

//-----------EInvoice-------------------
import EInvoiceIndex from "./components/pages/EInvoice/EInvoiceIndex";
import GSTItemBulkUpdate from "./components/pages/GSTBulkUpdate/GSTItemBulkUpdate";

import SalesRegisterReport from "./components/pages/SalesAnalysisReports/SalesRegisterReport";
import TaxRegisterSale from "./components/pages/GSTReports/TaxRegisterSale";
import TaxRegisterPurchase from "./components/pages/GSTReports/TaxRegisterPurchase";
import HSNTaxSummary from "./components/pages/GSTReports/HSNTaxSummary";
import PurchaseHSNSummary from "./components/pages/GSTReports/PurchaseHSNSummary";
import HSNSummary from "./components/pages/GSTReports/HSNSummary";
import GSTR3BReport from "./components/pages/GSTReports/GSTR3BReport";
import GSTR3BFormatReport from "./components/pages/GSTReports/GSTR3BFormatReport";
import SalesAnalysisReport from "./components/pages/SalesAnalysisReports/SalesAnalysisReport";
import DespatchAnalysisReport from "./components/pages/SalesAnalysisReports/DespatchAnalysisReport";
import SaleReturnAnalysisReport from "./components/pages/SalesAnalysisReports/SaleReturnAnalysisReport";
import YearOnYearSalesReport from "./components/pages/SalesAnalysisReports/YearOnYearSalesReport";
import PurchaseRegisterReport from "./components/pages/PurchaseAnalysisReports/PurchaseRegisterReport";
import OrderAnalysisReport from "./components/pages/PurchaseAnalysisReports/OrderAnalysisReport";
import PurchaseAnalysisReport from "./components/pages/PurchaseAnalysisReports/PurchaseAnalysisReport";
import PurchaseReturnAnalysisReport from "./components/pages/PurchaseAnalysisReports/PurchaseReturnAnalysisReport";
import YearOnYearPurchaseReport from "./components/pages/PurchaseAnalysisReports/YearOnYearPurchaseReport";

//-----------AssetReports-------------------
import AssetRegistration from "./components/pages/AssetReports/AssetRegistration";
import AssetDepreciation from "./components/pages/AssetReports/AssetDepreciation";

//-----------AuditLog-------------------
import AuditLogIndex from "./components/pages/AuditLog/AuditLogIndex";

//-----------Driver-------------------------
import CODList from "./components/pages/Driver/Cod";
import ExchangeList from "./components/pages/Driver/Exchange";




// ---------------- Theme ---------------- //
const theme = createTheme({
  palette: {
    primary: { main: "#1a1f3a" },
    secondary: { main: "#0f1419" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
        },
      },
    },
  },
});

// ---------------- Route-based AppBar color ---------------- //
// Auto-built from reportGroups — each group's color applies to all its report routes
const ROUTE_COLORS = (() => {
  const map = { '/ReportsHub': '#2c3e6e' };
  const groups = [
    { color: '#0d47a1', routes: ['/ProfitLossStatement', '/ProfitLossStatementTView', '/TradingProfitLoss', '/ProfitLossMonthWise', '/BalanceSheet', '/BalanceSheetTView', '/CashFlowStatement', '/FundFlowStatement', '/DepreciationStatement', '/BankReconciliation', '/TDSRegister', '/DailyProfitReport'] },
    { color: '#263078', routes: ['/DelayedPaymentReport', '/DelayedCollectionReport', '/CollectionReport', '/PaymentsReport', '/JournalBookReport', '/BankReceiptJournalReport', '/BankPaymentJournalReport', '/DayBookReport', '/DayBookSummaryReport', '/SaleJournalReport', '/PurchaseJournalReport', '/FinancialJournalHub', '/RatioAnalysisReport', '/BankBookReport'] },
    { color: '#4e342e', routes: ['/Ledger', '/CashBook', '/Outstanding', '/ExpenseReport', '/DetailedInvoice', '/IncomeExpenseReport', '/ExpenseAdvancedReport'] },
    { color: '#bf360c', routes: ['/PurchaseReport', '/PurchaseOrderStatusReport', '/VendorandItemWisePurchaseReport', '/VendorAgeingReport', '/PurchaseRegister', '/OrderAnalysisReport', '/PurchaseAnalysisReport', '/PurchaseReturnAnalysisReport', '/YearOnYearPurchaseReport'] },
    { color: '#1b5e20', routes: ['/SalesReport', '/SalesOrderReport', '/CustomerWiseSalesReport', '/CustomerAgeingReport', '/SalesRegister', '/SalesAnalysis', '/DespatchAnalysis', '/SaleReturnAnalysis', '/YearOnYearSales'] },
    { color: '#4a148c', routes: ['/StockTransferReport', '/StockMovementReport', '/StockSummaryReport', '/StockAnalysisReport', '/StockAgeingReport', '/RateAnalysisReport', '/ProductionWiseStockReport'] },
    { color: '#00695c', routes: ['/StockDayBook', '/StockLedger', '/DailyItemMovement', '/MonthlyItemMovement', '/StockTrail', '/StockTrailTransactionWise', '/StockTrailMonthWise', '/StockValuation', '/StockTransfer', '/FastSlowMovingItems', '/StockTrailTransactionWise'] },
    { color: '#1c2266', routes: ['/GSTR1', '/GSTR3B', '/GSTR3BReport', '/GSTR3BFormatReport', '/SaleGstReport', '/TaxRegisterSale', '/TaxRegisterPurchase', '/HSNTaxSummary', '/PurchaseHSNSummary', '/HSNSummary'] },
    { color: '#10586a', routes: ['/StockBasedReport', '/SalesBasedReport', '/BatchBasedReport', '/PartyWiseReport', '/SalesManWiseReport', '/StockMinimalLevelReport', '/ItemMovementAnalysisReport'] }, // Item Profitability
    { color: '#1c2266', routes: ['/SaleInvoiceRegister', '/SaleSummaryBillWise', '/SalesManCommissionSummary', '/SalesManCommissionPending', '/SalesManCommissionExceeded', '/SalePriceList', '/PaymentRemainder', '/BillWiseOutstanding', '/ClientGroupOutstandingReport', '/ClientBillWisePaymentDetails', '/ClientAgeingAnalysisBillWise', '/ClientAgeingFIFO', '/StaffSaleReport'] },
    { color: '#0d8392', routes: ['/PurchaseOrderWiseReport', '/PurchaseInvoiceRegister', '/PurchaseSummaryBillWise', '/PurchasePriceList', '/PurchasePaymentReminder', '/PurchaseBillWiseOutstanding', '/VendorGroupOutstandingReport', '/VendorBillWisePaymentDetails', '/VendorAgeingBillToBill', '/VendorAgeingFIFO'] },
    { color: '#0b9f69', routes: ['/AssetRegistration', '/AssetDepreciation'] }, // Assets
  ];
  groups.forEach(({ color, routes }) => routes.forEach(r => { if (!map[r]) map[r] = color; }));
  return map;
})();

const useAppBarColor = () => {
  const location = useLocation();
  return ROUTE_COLORS[location.pathname] || '#2c3e6e';
};

// ---------------- Layout ---------------- //
const AppBarWithColor = ({ companyName, username, isMobile }) => {
  const appBarColor = useAppBarColor();

  return (
    <AppBar position="fixed" elevation={0} sx={{
      zIndex: (t) => t.zIndex.drawer + 1,
      background: isMobile
        ? `linear-gradient(135deg, #1a1f5e 0%, #2c3e6e 60%, #1e3a8a 100%)`
        : appBarColor,
      backdropFilter: 'blur(12px)',
      borderBottom: isMobile ? '1px solid rgba(255,255,255,0.08)' : 'none',
      transition: 'background 0.3s ease',
      boxShadow: isMobile
        ? '0 2px 20px rgba(0,0,0,0.3)'
        : '0 2px 8px rgba(0,0,0,0.2)',
      paddingTop: 'env(safe-area-inset-top)',
    }}>
      <Toolbar sx={{ minHeight: '52px !important', height: '52px', px: isMobile ? 1.5 : 2, gap: 1 }}>
        {/* ── Logo / Brand ── */}
        <Box sx={{ flexShrink: 0, mr: isMobile ? 1 : 2 }}>
          <Link to="/Home" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? 1 : 1.5,
              position: 'relative',
              '&:hover .brand-logo-wrap': {
                transform: 'scale(1.06)',
                boxShadow: '0 0 18px rgba(99,179,237,0.55)',
              },
              '&:hover .brand-name': {
                letterSpacing: isMobile ? '1.5px' : '2px',
                color: '#e2f0ff',
              },
            }}>

              {/* Logo image — glowing pill container */}
              <Box
                className="brand-logo-wrap"
                sx={{
                  height: isMobile ? 34 : 40,
                  width: isMobile ? 34 : 40,
                  borderRadius: '10px',
                  background: 'linear-gradient(145deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.06) 100%)',
                  border: '1.5px solid rgba(255,255,255,0.22)',
                  boxShadow: '0 0 10px rgba(99,179,237,0.3), inset 0 1px 0 rgba(255,255,255,0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                  overflow: 'hidden',
                  backdropFilter: 'blur(6px)',
                  flexShrink: 0,
                }}
              >
                <img
                  src={MampillyLogo}
                  alt="Madavana"
                  style={{
                    height: isMobile ? '26px' : '30px',
                    width: 'auto',
                    objectFit: 'contain',
                    display: 'block',
                    filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.4))',
                  }}
                />
              </Box>

              {/* Brand text block */}
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', lineHeight: 1 }}>
                {/* Main brand name */}
                <Box
                  className="brand-name"
                  sx={{
                    fontFamily: '"Segoe UI", system-ui, sans-serif',
                    fontWeight: 800,
                    fontSize: isMobile ? '13px' : '15px',
                    letterSpacing: isMobile ? '1px' : '1.6px',
                    textTransform: 'uppercase',
                    color: '#ffffff',
                    textShadow: '0 1px 6px rgba(0,0,0,0.4)',
                    transition: 'letter-spacing 0.25s ease, color 0.25s ease',
                    whiteSpace: 'nowrap',
                    /* Shimmer effect on the text */
                    background: 'linear-gradient(90deg, #ffffff 0%, #bfdbfe 40%, #ffffff 60%, #93c5fd 100%)',
                    backgroundSize: '200% auto',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    animation: 'shimmerText 4s linear infinite',
                  }}
                >
                  MADAVANA
                </Box>

                {/* Sub-line — desktop only */}
                {!isMobile && (
                  <Box sx={{
                    fontFamily: '"Segoe UI", system-ui, sans-serif',
                    fontWeight: 400,
                    fontSize: '9.5px',
                    letterSpacing: '2.5px',
                    textTransform: 'uppercase',
                    color: 'rgba(191,219,254,0.8)',
                    mt: '2px',
                    whiteSpace: 'nowrap',
                  }}>
                    Electronics &amp; Home Appliances
                  </Box>
                )}
              </Box>

              {/* Vertical divider — desktop only */}
              {/* {!isMobile && (
                <Box sx={{
                  width: '1px',
                  height: '28px',
                  background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.3), transparent)',
                  mx: 0.5,
                  flexShrink: 0,
                }} />
              )} */}

              {/* Company name from API — desktop only */}
              {/* {!isMobile && companyName && (
                <Box sx={{
                  fontFamily: '"Segoe UI", system-ui, sans-serif',
                  fontWeight: 500,
                  fontSize: '12px',
                  letterSpacing: '0.5px',
                  color: 'rgba(226,240,255,0.85)',
                  maxWidth: '180px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                  {companyName}
                </Box>
              )} */}
            </Box>
          </Link>
        </Box>
        {!isMobile && username !== "Counter" && <HorizontalNavbar />}
        <Box sx={{ flexGrow: 1 }} />
        <Logout />
      </Toolbar>
    </AppBar>
  );
};

const Layout = () => {
  const { companyName, roleName, username, isAuthenticated } = useAuth();
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isAuthenticated && <SessionTimeout />}

      <PWAStatus
        showInstallPrompt={true}
        showUpdatePrompt={true}
        showOfflineStatus={true}
      />

      <AppBarWithColor companyName={companyName} username={username} isMobile={isMobile} />

      {/* Content — starts exactly below AppBar + iOS safe area */}
      <Box
        className="app-content-area"
        sx={{
          pt: 'calc(52px + env(safe-area-inset-top))',
          pb: isMobile ? 'calc(62px + env(safe-area-inset-bottom))' : 0,
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor: '#f0f4f8',
        }}
      >
        <Box
          className="app-route-content"
          sx={{ p: 0, flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', minHeight: 0 }}
        >
          <Switch>
            <Route path="/" exact render={() => {
              const role = (roleName || '').toLowerCase();
              const isExecutive = role.includes('executive');
              const isSalesman = role.includes('salesman') || role.includes('sales man');
              const isDriver = role.includes('driver');
              return isDriver ? <Redirect to="/DriverDashboard" /> : isExecutive ? <Redirect to="/SalesExecutiveDashboard" /> : isSalesman ? <Redirect to="/SalesManDashboard" /> : <Home />;
            }} />
            
            <Route path="/Home" exact render={() => {
              const role = (roleName || '').toLowerCase();
              const isExecutive = role.includes('executive');
              const isSalesman = role.includes('salesman') || role.includes('sales man');
              const isDriver = role.includes('driver');
              return isDriver ? <Redirect to="/DriverDashboard" /> : isExecutive ? <Redirect to="/SalesExecutiveDashboard" /> : isSalesman ? <Redirect to="/SalesManDashboard" /> : <Home />;
            }} />

            <Route path="/CODList" component={CODList} />
            <Route path="/ExchangeList" component={ExchangeList} />

            {/* Role */}
            <Route path="/RoleIndex" component={RoleIndex} />
            <Route path="/RoleDetail/:id" component={RoleDetail} />

            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />

            {/* Client */}
            <Route path="/ClientIndex" component={ClientIndex} />

            {/* Vendor */}
            <Route path="/VendorIndex" component={VendorIndex} />

            {/* Product */}
            <Route path="/ProductCategoryIndex" component={ProductCategoryIndex} />
            <Route path="/ProductSubCategoryIndex" component={ProductSubCategoryIndex} />
            <Route path="/ProductItemIndex" component={ProductItemIndex} />
            <Route path="/ProductBrandIndex" component={ProductBrandIndex} />
            {/* <Route path="/ProductRelationIndex" component={ProductRelationIndex} /> */}

            {/* Bank */}
            <Route path="/BankIndex" component={BankIndex} />

            {/* Master */}
            <Route path="/MasterDashboard" component={MasterDashboard} />
            <Route path="/ClientIndex" component={ClientIndex} />
            <Route path="/VendorIndex" component={VendorIndex} />

            {/* AccountHead */}
            <Route path="/AccountHeadDashboard" component={AccountHeadDashboard} />
            <Route path="/AccountHeadIndex" component={AccountHeadIndex} />
            <Route path="/AssetIndex" component={AssetIndex} />
            <Route path="/CapitalIndex" component={CapitalIndex} />
            <Route path="/OtherOptionIndex" component={OtherOptionIndex} />
            <Route path="/SalesExecutiveIndex" component={SalesExecutiveIndex} />
            <Route path="/SalesManDashboard" component={SalesManDashboard} />
            <Route path="/SalesExecutiveDashboard" component={SalesExecutiveDashboard} />
            <Route path="/DriverDashboard" component={DriverDashboard} />

            {/* Delivery / Schedules */}
            <Route path="/Schedules" component={Schedules} />
            <Route path="/InstallationScheduleList" component={InstallationScheduleList} />
            <Route path="/OnsiteExchangeList" component={OnsiteExchangeList} />
            <Route path="/CashOnDeliveryList" component={CashOnDeliveryList} />
            <Route path="/BalanceSheetHeadIndex" component={BalanceSheetHeadIndex} />

            {/* PurchaseOrder */}
            <Route path="/PurchaseOrderIndex" component={PurchaseOrderIndex} />

            {/* Purchase */}
            <Route path="/PurchaseIndex" component={PurchaseIndex} />

            {/* PurchaseReturn */}
            <Route path="/PurchaseReturnAgainstIndex" component={PurchaseReturnAgainstIndex} />

            {/* Quotation */}
            <Route path="/QuotationIndex" component={QuotationIndex} />

            {/* Enquiry */}
            <Route path="/EnquiryIndex" component={EnquiryIndex} />
            <Route path="/EnquiryForm/:action/:id?" component={EnquiryForm} />

            {/* Scheme */}
            <Route path="/SchemeIndex" component={SchemeIndex} />
            <Route path="/SchemeForm/:action/:id?" component={SchemeForm} />

            {/* SalesOrder */}
            <Route path="/SaleOrderIndex" component={SalesOrderIndex} />

            {/* Sale */}
            <Route path="/SaleIndex" component={SaleIndex} />

            {/* SaleReturn */}
            <Route path="/SalesReturnIndex" component={SaleReturnIndex} />

            {/* Stock */}
            <Route path="/StockTransferInIndex" component={StockTransferInIndex} />
            <Route path="/StockTransferOutIndex" component={StockTransferOutIndex} />

            {/* Production */}
            <Route path="/ProductionIndex" component={ProductionIndex} />

            {/* PaymentReceipts */}
            <Route path="/PaymentAndReceiptIndex" component={PaymentReceiptsIndex} />

            {/* JournalEntry */}
            <Route path="/JournalEntryIndex" component={JournalEntryIndex} />

            {/* Reports */}
            <Route path="/ReportsHub" component={ReportsHub} />
            <Route path="/Ledger" component={LedgerReport} />
            <Route path="/PurchaseReport" component={PurchaseReport} />
            <Route path="/PurchaseOrderStatusReport" component={PurchaseOrderStatusReport} />
            <Route path="/VendorAgeingReport" component={VendorAgeingReport} />
            <Route path="/VendorandItemWisePurchaseReport" component={VendorandItemWisePurchaseReport} />
            <Route path="/PurchaseOrderWiseReport" component={PurchaseOrderWiseReport} />
            <Route path="/PurchaseInvoiceRegister" component={PurchaseInvoiceRegister} />
            <Route path="/PurchaseSummaryBillWise" component={PurchaseSummaryBillWise} />
            <Route path="/PurchasePriceList" component={PurchasePriceList} />
            <Route path="/PurchasePaymentReminder" component={PurchasePaymentReminder} />
            <Route path="/PurchaseBillWiseOutstanding" component={PurchaseBillWiseOutstanding} />
            <Route path="/VendorBillWisePaymentDetails" component={VendorBillWisePaymentDetails} />
            <Route path="/VendorAgeingBillToBill" component={VendorAgeingBillToBill} />
            <Route path="/VendorAgeingFIFO" component={VendorAgeingFIFO} />
            <Route path="/VendorGroupOutstandingReport" component={VendorGroupOutstandingReport} />
            <Route path="/SalePriceList" component={SalePriceList} />
            <Route path="/SaleInvoiceRegister" component={SaleInvoiceRegister} />
            <Route path="/StaffSaleReport" component={StaffSaleReport} />
            <Route path="/SaleSummaryBillWise" component={SaleSummaryBillWise} />
            <Route path="/SalesManCommissionSummary" component={SalesManCommissionSummary} />
            <Route path="/SalesManCommissionPending" component={SalesManCommissionPending} />
            <Route path="/SalesManCommissionExceeded" component={SalesManCommissionExceeded} />
            <Route path="/PaymentRemainder" component={PaymentRemainder} />
            <Route path="/BillWiseOutstanding" component={BillWiseOutstanding} />
            <Route path="/ClientBillWisePaymentDetails" component={ClientBillWisePaymentDetails} />
            <Route path="/ClientAgeingAnalysisBillWise" component={ClientAgeingAnalysisBillWise} />
            <Route path="/ClientAgeingFIFO" component={ClientAgeingFIFO} />
            <Route path="/ClientGroupOutstandingReport" component={ClientGroupOutstandingReport} />
            <Route path="/StockMovementReport" component={StockMovementReport} />
            <Route path="/StockSummaryReport" component={StockSummaryReport} />
            <Route path="/StockAnalysisReport" component={StockAnalysisReport} />
            <Route path="/StockAgeingReport" component={StockAgeingReport} />
            <Route path="/RateAnalysisReport" component={RateAnalysisReport} />
            <Route path="/ProductionWiseStockReport" component={ProductionWiseStockReport} />
            <Route path="/StockBasedReport" component={StockBasedReport} />
            <Route path="/SalesBasedReport" component={SalesBasedReport} />
            <Route path="/BatchBasedReport" component={BatchBasedReport} />
            <Route path="/PartyWiseReport" component={PartyWiseReport} />
            <Route path="/SalesManWiseReport" component={SalesManWiseReport} />
            <Route path="/StockMinimalLevelReport" component={StockMinimalLevelReport} />
            <Route path="/ItemMovementAnalysisReport" component={ItemMovementAnalysisReport} />
            <Route path="/StockDayBook" component={StockDayBook} />
            <Route path="/StockLedger" component={StockLedger} />
            <Route path="/DailyItemMovement" component={DailyItemMovement} />
            <Route path="/MonthlyItemMovement" component={MonthlyItemMovement} />
            <Route path="/FastSlowMovingItems" component={FastSlowMovingItems} />
            <Route path="/StockTrail" component={StockTrail} />
            <Route path="/StockTrailTransactionWise" component={StockTrail} />
            <Route path="/StockTrailMonthWise" component={StockTrailMonthWise} />
            <Route path="/StockValuation" component={StockValuation} />
            <Route path="/StockTransfer" component={StockTransferInventory} />
            <Route path="/SalesReport" component={SaleReport} />
            <Route path="/CustomerWiseSalesReport" component={CustomerandItemWiseSaleReport} />
            <Route path="/CustomerAgeingReport" component={CustomerAgeingReport} />
            <Route path="/SalesOrderReport" component={SaleOrderStatusReport} />
            <Route path="/SalesRegister" component={SalesRegisterReport} />
            <Route path="/SalesAnalysis" component={SalesAnalysisReport} />
            <Route path="/DespatchAnalysis" component={DespatchAnalysisReport} />
            <Route path="/SaleReturnAnalysis" component={SaleReturnAnalysisReport} />
            <Route path="/YearOnYearSales" component={YearOnYearSalesReport} />
            <Route path="/PurchaseRegister" component={PurchaseRegisterReport} />
            <Route path="/OrderAnalysisReport" component={OrderAnalysisReport} />
            <Route path="/PurchaseAnalysisReport" component={PurchaseAnalysisReport} />
            <Route path="/PurchaseReturnAnalysisReport" component={PurchaseReturnAnalysisReport} />
            <Route path="/YearOnYearPurchaseReport" component={YearOnYearPurchaseReport} />
            <Route path="/CashBook" component={CashBook} />
            <Route path="/SaleGstReport" component={SaleGstReport} />
            <Route path="/StockTransferReport" component={StockTransferReport} />
            <Route path="/TrialBalanceReport" component={TrialBalanceReport} />
            <Route path="/TrialBalanceAdvancedReport" component={TrialBalanceAdvancedReport} />
            <Route path="/DailyProfitReport" component={DailyProfitReport} />
            <Route path="/StaffTargetReport" component={StaffTargetReport} />
            <Route path="/StockBranchWiseReport" component={StockBranchWiseReport} />
            <Route path="/CashOnDeliveryPaymentStatusReport" component={CashOnDeliveryPaymentStatusReport} />
            <Route path="/DelayedPaymentReport" component={DelayedPaymentReport} />
            <Route path="/DelayedCollectionReport" component={DelayedCollectionReport} />
            <Route path="/CollectionReport" component={CollectionReport} />
            <Route path="/PaymentsReport" component={PaymentsReport} />
            <Route path="/JournalBookReport" component={JournalBookReport} />
            <Route path="/BankReceiptJournalReport" component={BankReceiptJournalReport} />
            <Route path="/BankPaymentJournalReport" component={BankPaymentJournalReport} />
            <Route path="/BankBookReport" component={BankBookReport} />
            <Route path="/DayBookReport" component={DayBookReport} />
            <Route path="/DayBookSummaryReport" component={DayBookSummaryReport} />
            <Route path="/SaleJournalReport" component={SaleJournalReport} />
            <Route path="/PurchaseJournalReport" component={PurchaseJournalReport} />
            <Route path="/RatioAnalysisReport" component={RatioAnalysisReport} />
            <Route path="/SchemeSummaryReport" component={SchemeSummaryReport} />
            <Route path="/CashFlowStatement" component={CashFlowStatement} />
            <Route path="/ProfitLossMonthWise" component={ProfitLossMonthWise} />
            <Route path="/FundFlowStatement" component={FundFlowStatement} />
            <Route path="/BalanceSheet" component={BalanceSheet} />
            <Route path="/BalanceSheetTView" component={BalanceSheetTView} />
            <Route path="/IncomeExpenseReport" component={IncomeExpenseReport} />
            <Route path="/ExpenseAdvancedReport" component={ExpenseReport} />
            <Route path="/DetailedInvoice" component={DetailedInvoiceReport} />
            <Route path="/TaxRegisterSale" component={TaxRegisterSale} />
            <Route path="/GSTR3BReport" component={GSTR3BReport} />
            <Route path="/GSTR3BFormatReport" component={GSTR3BFormatReport} />
            <Route path="/TaxRegisterPurchase" component={TaxRegisterPurchase} />
            <Route path="/HSNTaxSummary" component={HSNTaxSummary} />
            <Route path="/PurchaseHSNSummary" component={PurchaseHSNSummary} />
            <Route path="/HSNSummary" component={HSNSummary} />

            {/* EInvoice */}
            <Route path="/EInvoiceIndex" component={EInvoiceIndex} />
            <Route path="/GSTItemBulkUpdate" component={GSTItemBulkUpdate} />

            {/* Asset Reports */}
            <Route path="/AssetRegistration" component={AssetRegistration} />
            <Route path="/AssetDepreciation" component={AssetDepreciation} />

            {/* Audit Log */}
            <Route path="/AuditLogIndex" component={AuditLogIndex} />

            {/* Company */}
            <Route path="/CompanyEdit" component={CompanyEdit} />

          </Switch>
        </Box>
      </Box>

      {/* Mobile Bottom Navigation */}
      {isMobile && username !== "Counter" && <MobileBottomNav />}
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const SESSION_KEY = 'app_current_path';

// Create history with the saved path as the starting location,
// so the Router's initial location is correct before any component mounts.
const savedPath = sessionStorage.getItem(SESSION_KEY);
const appHistory = createBrowserHistory();
if (savedPath && savedPath !== '/') {
  appHistory.replace(savedPath);
  sessionStorage.removeItem(SESSION_KEY);
}

const App = () => {
  useEffect(() => {
    // ── URL Masking: intercept pushState/replaceState to save real path ──
    const APP_DISPLAY = window.location.origin;

    const _push = window.history.pushState.bind(window.history);
    const _replace = window.history.replaceState.bind(window.history);

    window.history.pushState = (s, t, u) => {
      if (u && u !== APP_DISPLAY) sessionStorage.setItem(SESSION_KEY, u);
      _push(s, t, APP_DISPLAY);
    };
    window.history.replaceState = (s, t, u) => {
      if (u && u !== APP_DISPLAY) sessionStorage.setItem(SESSION_KEY, u);
      _replace(s, t, APP_DISPLAY);
    };

    // Mask the URL now (after history is set up)
    window.history.replaceState(null, '', APP_DISPLAY);

    return () => {
      window.history.pushState = _push;
      window.history.replaceState = _replace;
    };
  }, []);

  useEffect(() => {
    // Register service worker with enhanced features
    serviceWorkerRegistration.register({
      onSuccess: (registration) => {
        console.log('SW registered successfully');
      },
      onUpdate: (registration) => {
        console.log('SW update available');
      }
    });

    // Handle PWA install prompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      window.deferredPrompt = e;
    };

    const handleAppInstalled = () => {
      console.log('PWA was installed');
      window.deferredPrompt = null;
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  return (
    <Router history={appHistory}>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
